interface StorageProgressBarProps {
  usedGB: number
  limitGB: number
  percentage: number
}

export function StorageProgressBar({ usedGB, limitGB, percentage }: StorageProgressBarProps) {
  // Get color based on usage percentage
  const getProgressColor = () => {
    if (percentage >= 90) return "bg-destructive"
    if (percentage >= 75) return "bg-amber-500"
    return "bg-primary"
  }

  return (
    <div className="space-y-2">
      <div className="flex justify-between text-sm">
        <span>Storage Usage</span>
        <span className="font-medium">{usedGB} GB / {limitGB} GB</span>
      </div>
      <div className="relative h-4 w-full overflow-hidden rounded-full bg-secondary/20">
        <div
          className={`h-full transition-all duration-300 ${getProgressColor()}`}
          style={{ width: `${Math.min(percentage, 100)}%` }}
        />
      </div>
      <div className="flex justify-between text-xs text-secondary">
        <span>{percentage}% used</span>
        <span>{(limitGB - usedGB).toFixed(2)} GB remaining</span>
      </div>
    </div>
  )
}